import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../contexts/AuthContext";
import { LanguageToggle } from "./LanguageToggle";

const NavIcon = ({ name }) => {
  const icons = {
    grid: <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>,
    building: <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5"/></svg>,
    home: <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><path d="M9 22V12h6v10"/></svg>,
    bed: <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><path d="M2 4v16m20-8v8m-20 0h20M2 12h20M6 12V8h4v4M14 12V8h4v4"/></svg>,
    briefcase: <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/></svg>,
    crane: <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><path d="M2 20h20M6 20V10l4-6h4l4 6v10M10 20v-6h4v6M10 10h4"/></svg>,
    office: <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><rect x="4" y="2" width="16" height="20" rx="1"/><path d="M9 6h2M13 6h2M9 10h2M13 10h2M9 14h2M13 14h2M9 18h6"/></svg>,
    beach: <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><path d="M17 21H7M12 3v18M5 8c2-3 5-5 7-5s5 2 7 5M3 12c3-2 6-3 9-3s6 1 9 3"/></svg>,
    fonds: <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><path d="M3 3h18v4H3zM5 7v12a2 2 0 002 2h10a2 2 0 002-2V7"/><path d="M10 12h4"/></svg>,
    map: <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><path d="M1 6v16l7-4 8 4 7-4V2l-7 4-8-4-7 4z"/><path d="M8 2v16M16 6v16"/></svg>,
    folder: <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><path d="M3 7a2 2 0 012-2h4l2 3h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V7z"/></svg>,
    orgchart: <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><rect x="9" y="2" width="6" height="4" rx="1"/><rect x="2" y="14" width="6" height="4" rx="1"/><rect x="16" y="14" width="6" height="4" rx="1"/><path d="M12 6v4M12 10H5M12 10h7M5 10v4M19 10v4"/></svg>,
    users: <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>,
    team: <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>,
    history: <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>,
    briefcase: <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><rect x="3" y="7" width="18" height="13" rx="1"/><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M3 13h18"/></svg>,
    key: <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 11-7.778 7.778 5.5 5.5 0 017.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/></svg>,
  };
  return icons[name] || null;
};

export const Layout = ({ children }) => {
  const { user, logout, isAdmin } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => { logout(); navigate("/login"); };

  const navItems = [
    { path: "/", label: t("nav.dashboard"), icon: "grid" },
    { path: "/assets", label: t("nav.all_assets"), icon: "building" },
    { path: "/map", label: t("nav.map"), icon: "map" },
    { path: "/dossiers", label: t("nav.dossiers"), icon: "folder" },
    { divider: true },
    { path: "/assets?pole=habitation", label: t("nav.habitation"), icon: "home" },
    { path: "/assets?pole=hotelerie", label: t("nav.hotellerie"), icon: "bed" },
    { path: "/assets?pole=commercial", label: t("nav.commercial"), icon: "briefcase" },
    { path: "/assets?pole=promotion", label: t("nav.promotion"), icon: "crane" },
    { path: "/assets?pole=bureaux", label: t("nav.bureaux"), icon: "office" },
    { path: "/assets?pole=plage_restaurant", label: t("nav.autres"), icon: "beach" },
    { path: "/assets?pole=fonds_commerce", label: t("nav.fonds_commerce"), icon: "fonds" },
    { divider: true },
    { path: "/orgchart", label: t("nav.orgchart"), icon: "orgchart" },
    { path: "/associates", label: t("nav.associates"), icon: "users" },
    { path: "/teams", label: t("nav.teams"), icon: "team" },
    { path: "/legacy", label: t("nav.legacy"), icon: "history" },
    { path: "/advisors", label: t("nav.advisors"), icon: "briefcase" },
    ...(isAdmin ? [
      { divider: true },
      { path: "/admin/visitor-access", label: t("nav.visitor_access"), icon: "key", adminOnly: true },
    ] : []),
  ];

  return (
    <div className="min-h-screen bg-background flex">
      <aside className={`fixed lg:static inset-y-0 left-0 z-50 w-72 bg-white border-r border-border transform ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0 transition-transform duration-300`}>
        <div className="flex flex-col h-full">
          <div className="p-8 border-b border-border flex items-start justify-between gap-3">
            <Link to="/" className="block">
              <h1 className="font-heading text-xl tracking-tight text-foreground">{t("app.brand")}</h1>
              <p className="text-xs text-muted-foreground mt-1 tracking-wider uppercase">{t("app.subtitle")}</p>
            </Link>
            <LanguageToggle />
          </div>
          <nav className="flex-1 p-6 space-y-2">
            {navItems.map((item, idx) => 
              item.divider ? (
                <div key={`divider-${idx}`} className="border-t border-border my-3" />
              ) : (
              <button key={item.path} onClick={() => { setSidebarOpen(false); window.location.href = window.location.origin + item.path; }}
                className="w-full flex items-center gap-3 px-4 py-3 text-muted-foreground hover:text-foreground hover:bg-muted transition-colors font-heading text-sm text-left"
                data-testid={`nav-${item.icon}`}>
                <NavIcon name={item.icon} />
                {item.label}
              </button>
              )
            )}
          </nav>
          <div className="p-6 border-t border-border">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-secondary flex items-center justify-center text-foreground font-heading">
                {user?.name?.charAt(0).toUpperCase()}
              </div>
              <div>
                <p className="font-medium text-sm text-foreground">{user?.name}</p>
                <p className="text-xs text-muted-foreground">{user?.role === "visitor" ? t("nav.visitor_readonly_role") : t("nav.administrator")}</p>
              </div>
            </div>
            <button onClick={handleLogout} className="w-full text-left px-4 py-2 text-sm text-muted-foreground hover:text-destructive transition-colors" data-testid="logout-btn">{t("nav.logout")}</button>
          </div>
        </div>
      </aside>
      <div className="lg:hidden fixed top-0 left-0 right-0 z-40 bg-white border-b border-border px-4 py-4 flex items-center justify-between">
        <button onClick={() => setSidebarOpen(true)} className="p-2" data-testid="mobile-menu-btn">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 6h16M4 12h16M4 18h16" /></svg>
        </button>
        <h1 className="font-heading text-lg">{t("app.brand")}</h1>
        <div className="w-10" />
      </div>
      {sidebarOpen && <div className="lg:hidden fixed inset-0 bg-black/50 z-40" onClick={() => setSidebarOpen(false)} />}
      {!isAdmin && (
        <div className="fixed top-16 lg:top-0 left-0 lg:left-72 right-0 bg-gold/10 border-b border-gold/30 px-4 py-2 z-30">
          <p className="text-sm text-center text-gold-dark">
            <svg className="w-4 h-4 inline mr-2" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
            {t("nav.visitor_banner")}
          </p>
        </div>
      )}
      <main className="flex-1 lg:ml-0 mt-16 lg:mt-0">
        <div className={`p-6 lg:p-10 ${!isAdmin ? 'pt-12 lg:pt-16' : ''}`}>{children}</div>
      </main>
    </div>
  );
};
